export default __webpack_public_path__ + "static/media/all-applied.c637e20a.svg";